import { Box, CssBaseline, Typography } from "@mui/material";
import { FC, ReactNode } from "react";
import SideBar from "./sidebar-component";

interface Props {
  children: ReactNode;
}

const Layout: FC<Props> = ({children} :Props) => {
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <SideBar />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        {children}
      </Box>
    </Box>
  );
};

export default Layout;